import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import styles from './PermissionAlert.module.css';

interface PermissionAlertProps {
  message: string;
  onClose: () => void;
}

export const PermissionAlert: React.FC<PermissionAlertProps> = ({ message, onClose }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.alert}>
        <div className={styles.header}>
          <AlertTriangle className={styles.icon} />
          <h3>Acesso Negado</h3>
          <button onClick={onClose} className={styles.closeButton}>
            <X size={20} />
          </button>
        </div>
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  );
};
